import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import NumberFormat from "react-number-format";

export default class Tweet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: this.props.text,
      likes: this.props.likes,
      date: this.props.date,
      img: this.props.img,
      emoji: this.props.emoji,
      post_liked: false,
    };
  }

  componentDidMount() {
    console.log(this.props);
  }

  render() {
    return (
      <div class="tweetItem">
        <div className="tweetHeader">
          <Link to="/realdonaldtrump">
            <img
              src="https://static01.nyt.com/newsgraphics/2019/08/01/candidate-pages/3b31eab6a3fd70444f76f133924ae4317567b2b5/trump-circle.png"
              alt=""
            />
          </Link>
          <div className="tweetUserInfo">
            <p>
              <Link to="/realdonaldtrump">Donald J. Trump</Link>
              <svg
                title="Verified (This is the real Donald Trump)"
                viewBox="0 0 24 24"
                aria-label="Verified account"
                class="r-13gxpu9 r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-1plcrui r-lrvibr"
              >
                <g>
                  <path
                    fill="#f20000"
                    d="M22.5 12.5c0-1.58-.875-2.95-2.148-3.6.154-.435.238-.905.238-1.4 0-2.21-1.71-3.998-3.818-3.998-.47 0-.92.084-1.336.25C14.818 2.415 13.51 1.5 12 1.5s-2.816.917-3.437 2.25c-.415-.165-.866-.25-1.336-.25-2.11 0-3.818 1.79-3.818 4 0 .494.083.964.237 1.4-1.272.65-2.147 2.018-2.147 3.6 0 1.495.782 2.798 1.942 3.486-.02.17-.032.34-.032.514 0 2.21 1.708 4 3.818 4 .47 0 .92-.086 1.335-.25.62 1.334 1.926 2.25 3.437 2.25 1.512 0 2.818-.916 3.437-2.25.415.163.865.248 1.336.248 2.11 0 3.818-1.79 3.818-4 0-.174-.012-.344-.033-.513 1.158-.687 1.943-1.99 1.943-3.484zm-6.616-3.334l-4.334 6.5c-.145.217-.382.334-.625.334-.143 0-.288-.04-.416-.126l-.115-.094-2.415-2.415c-.293-.293-.293-.768 0-1.06s.768-.294 1.06 0l1.77 1.767 3.825-5.74c.23-.345.696-.436 1.04-.207.346.23.44.696.21 1.04z"
                  ></path>
                </g>
              </svg>
            </p>
            <span>@realDonaldTrump</span>
          </div>
        </div>
        <div className="tweetBody">
          <p>
            {this.state.text}{" "}
            {this.state.emoji == true ? (
              <img
                class="emoji"
                src="https://trumpoji.com/images/emojis/deal_with_it_2_256.png"
                height="20px"
              />
            ) : (
              <></>
            )}
          </p>
          {this.state.img ? <img src={this.state.img} width="80%" /> : <></>}
        </div>
        <div className="tweetFooter">
          <div className="likes">
            <span
              onClick={() => {
                if (this.state.post_liked == false) {
                  this.setState({ post_liked: true });
                  this.setState({ likes: this.state.likes + 1 });
                } else {
                  this.setState({ post_liked: false });
                  this.setState({ likes: this.state.likes - 1 });
                }
              }}
            >
              {this.state.post_liked ? (
                <i
                  style={{
                    marginRight: "7px",
                    cursor: "pointer",
                  }}
                  className="bi bi-heart-fill"
                ></i>
              ) : (
                <i
                  style={{
                    marginRight: "7px",
                    cursor: "pointer",
                  }}
                  className="bi bi-heart"
                ></i>
              )}
            </span>

            <NumberFormat
              value={this.state.likes}
              displayType="text"
              thousandSeparator=","
            />
          </div>
          <div className="date">{this.state.date}</div>
        </div>
      </div>
    );
  }
}
